// wasm/build/wasm-module-1024.js
var MLKEM1024Module = (() => {
  var _scriptDir = import.meta.url;
  return (function(moduleArg = {}) {
    var Module = moduleArg;
    var readyPromiseResolve, readyPromiseReject;
    Module["ready"] = new Promise((resolve, reject) => {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
    var moduleOverrides = Object.assign({}, Module);
    var ENVIRONMENT_IS_WEB = typeof window == "object";
    var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
    var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
    var scriptDirectory = "";
    function locateFile(path) {
      return scriptDirectory + path;
    }
    var read_, readAsync, readBinary;
    if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
      if (ENVIRONMENT_IS_WORKER) {
        scriptDirectory = self.location.href;
      } else if (typeof document != "undefined" && document.currentScript) {
        scriptDirectory = document.currentScript.src;
      }
      if (_scriptDir) {
        scriptDirectory = _scriptDir;
      }
      if (scriptDirectory.indexOf("blob:") !== 0) {
        scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
      } else {
        scriptDirectory = "";
      }
      {
        read_ = (url) => {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, false);
          xhr.send(null);
          return xhr.responseText;
        };
        if (ENVIRONMENT_IS_WORKER) {
          readBinary = (url) => {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.responseType = "arraybuffer";
            xhr.send(null);
            return new Uint8Array(xhr.response);
          };
        }
        readAsync = (url, onload, onerror) => {
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url, true);
          xhr.responseType = "arraybuffer";
          xhr.onload = () => {
            if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
              onload(xhr.response);
              return;
            }
            onerror();
          };
          xhr.onerror = onerror;
          xhr.send(null);
        };
      }
    } else {
    }
    var out = console.log.bind(console);
    var err = console.error.bind(console);
    Object.assign(Module, moduleOverrides);
    moduleOverrides = null;
    var wasmBinary;
    if (typeof WebAssembly != "object") {
      abort("no native wasm support detected");
    }
    function intArrayFromBase64(s) {
      var decoded = atob(s);
      var bytes = new Uint8Array(decoded.length);
      for (var i = 0; i < decoded.length; ++i) {
        bytes[i] = decoded.charCodeAt(i);
      }
      return bytes;
    }
    function tryParseAsDataURI(filename) {
      if (!isDataURI(filename)) {
        return;
      }
      return intArrayFromBase64(filename.slice(dataURIPrefix.length));
    }
    var wasmMemory;
    var ABORT = false;
    var EXITSTATUS;
    var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateMemoryViews() {
      var b = wasmMemory.buffer;
      Module["HEAP8"] = HEAP8 = new Int8Array(b);
      Module["HEAP16"] = HEAP16 = new Int16Array(b);
      Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
      Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
      Module["HEAP32"] = HEAP32 = new Int32Array(b);
      Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
      Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
      Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATPOSTRUN__ = [];
    var runtimeInitialized = false;
    function preRun() {
      callRuntimeCallbacks(__ATPRERUN__);
    }
    function initRuntime() {
      runtimeInitialized = true;
      callRuntimeCallbacks(__ATINIT__);
    }
    function postRun() {
      callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnInit(cb) {
      __ATINIT__.unshift(cb);
    }
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function addRunDependency(id) {
      runDependencies++;
    }
    function removeRunDependency(id) {
      runDependencies--;
      if (runDependencies == 0) {
        if (runDependencyWatcher !== null) {
          clearInterval(runDependencyWatcher);
          runDependencyWatcher = null;
        }
        if (dependenciesFulfilled) {
          var callback = dependenciesFulfilled;
          dependenciesFulfilled = null;
          callback();
        }
      }
    }
    function abort(what) {
      what = "Aborted(" + what + ")";
      err(what);
      ABORT = true;
      EXITSTATUS = 1;
      what += ". Build with -sASSERTIONS for more info.";
      var e = new WebAssembly.RuntimeError(what);
      readyPromiseReject(e);
      throw e;
    }
    var dataURIPrefix = "data:application/octet-stream;base64,";
    var isDataURI = (filename) => filename.startsWith(dataURIPrefix);
    var wasmBinaryFile;
    wasmBinaryFile = "data:application/octet-stream;base64,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";
    if (!isDataURI(wasmBinaryFile)) {
      wasmBinaryFile = locateFile(wasmBinaryFile);
    }
    function getBinarySync(file) {
      if (file == wasmBinaryFile && wasmBinary) {
        return new Uint8Array(wasmBinary);
      }
      var binary = tryParseAsDataURI(file);
      if (binary) {
        return binary;
      }
      if (readBinary) {
        return readBinary(file);
      }
      throw "both async and sync fetching of the wasm failed";
    }
    function getBinaryPromise(binaryFile) {
      return Promise.resolve().then(() => getBinarySync(binaryFile));
    }
    function instantiateArrayBuffer(binaryFile, imports, receiver) {
      return getBinaryPromise(binaryFile).then((binary) => WebAssembly.instantiate(binary, imports)).then((instance) => instance).then(receiver, (reason) => {
        err(`failed to asynchronously prepare wasm: ${reason}`);
        abort(reason);
      });
    }
    function instantiateAsync(binary, binaryFile, imports, callback) {
      return instantiateArrayBuffer(binaryFile, imports, callback);
    }
    function createWasm() {
      var info = { "a": wasmImports };
      function receiveInstance(instance, module) {
        wasmExports = instance.exports;
        wasmMemory = wasmExports["b"];
        updateMemoryViews();
        addOnInit(wasmExports["c"]);
        removeRunDependency("wasm-instantiate");
        return wasmExports;
      }
      addRunDependency("wasm-instantiate");
      function receiveInstantiationResult(result) {
        receiveInstance(result["instance"]);
      }
      instantiateAsync(wasmBinary, wasmBinaryFile, info, receiveInstantiationResult).catch(readyPromiseReject);
      return {};
    }
    var callRuntimeCallbacks = (callbacks) => {
      while (callbacks.length > 0) {
        callbacks.shift()(Module);
      }
    };
    function getValue(ptr, type = "i8") {
      if (type.endsWith("*")) type = "*";
      switch (type) {
        case "i1":
          return HEAP8[ptr >> 0];
        case "i8":
          return HEAP8[ptr >> 0];
        case "i16":
          return HEAP16[ptr >> 1];
        case "i32":
          return HEAP32[ptr >> 2];
        case "i64":
          abort("to do getValue(i64) use WASM_BIGINT");
        case "float":
          return HEAPF32[ptr >> 2];
        case "double":
          return HEAPF64[ptr >> 3];
        case "*":
          return HEAPU32[ptr >> 2];
        default:
          abort(`invalid type for getValue: ${type}`);
      }
    }
    function setValue(ptr, value, type = "i8") {
      if (type.endsWith("*")) type = "*";
      switch (type) {
        case "i1":
          HEAP8[ptr >> 0] = value;
          break;
        case "i8":
          HEAP8[ptr >> 0] = value;
          break;
        case "i16":
          HEAP16[ptr >> 1] = value;
          break;
        case "i32":
          HEAP32[ptr >> 2] = value;
          break;
        case "i64":
          abort("to do setValue(i64) use WASM_BIGINT");
        case "float":
          HEAPF32[ptr >> 2] = value;
          break;
        case "double":
          HEAPF64[ptr >> 3] = value;
          break;
        case "*":
          HEAPU32[ptr >> 2] = value;
          break;
        default:
          abort(`invalid type for setValue: ${type}`);
      }
    }
    var _emscripten_memcpy_js = (dest, src, num) => HEAPU8.copyWithin(dest, src, src + num);
    var wasmImports = { a: _emscripten_memcpy_js };
    var wasmExports = createWasm();
    var ___wasm_call_ctors = () => (___wasm_call_ctors = wasmExports["c"])();
    var _mlkem1024_keypair_derand = Module["_mlkem1024_keypair_derand"] = (a0, a1, a2) => (_mlkem1024_keypair_derand = Module["_mlkem1024_keypair_derand"] = wasmExports["d"])(a0, a1, a2);
    var _mlkem1024_enc_derand = Module["_mlkem1024_enc_derand"] = (a0, a1, a2, a3) => (_mlkem1024_enc_derand = Module["_mlkem1024_enc_derand"] = wasmExports["e"])(a0, a1, a2, a3);
    var _mlkem1024_dec = Module["_mlkem1024_dec"] = (a0, a1, a2) => (_mlkem1024_dec = Module["_mlkem1024_dec"] = wasmExports["f"])(a0, a1, a2);
    var ___errno_location = () => (___errno_location = wasmExports["__errno_location"])();
    var stackSave = () => (stackSave = wasmExports["h"])();
    var stackRestore = (a0) => (stackRestore = wasmExports["i"])(a0);
    var stackAlloc = (a0) => (stackAlloc = wasmExports["j"])(a0);
    Module["stackAlloc"] = stackAlloc;
    Module["stackSave"] = stackSave;
    Module["stackRestore"] = stackRestore;
    Module["setValue"] = setValue;
    Module["getValue"] = getValue;
    var calledRun;
    dependenciesFulfilled = function runCaller() {
      if (!calledRun) run();
      if (!calledRun) dependenciesFulfilled = runCaller;
    };
    function run() {
      if (runDependencies > 0) {
        return;
      }
      preRun();
      if (runDependencies > 0) {
        return;
      }
      function doRun() {
        if (calledRun) return;
        calledRun = true;
        Module["calledRun"] = true;
        if (ABORT) return;
        initRuntime();
        readyPromiseResolve(Module);
        postRun();
      }
      {
        doRun();
      }
    }
    run();
    return moduleArg.ready;
  });
})();
var wasm_module_1024_default = MLKEM1024Module;

// mlkem-src/mlkem1024.ts
var ALGORITHM_NAME = "ML-KEM-1024";
var JWK_ALG = "MLKEM1024";
var KEY_USAGES = [
  "encapsulateKey",
  "encapsulateBits",
  "decapsulateKey",
  "decapsulateBits"
];
var MlKemOperationError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "OperationError";
  }
};
var MlKemInvalidAccessError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "InvalidAccessError";
  }
};
var MlKemNotSupportedError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "NotSupportedError";
  }
};
var MlKemDataError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "DataError";
  }
};
var internalKeyData = /* @__PURE__ */ new WeakMap();
function getInternalKeyData(key) {
  const keyData = internalKeyData.get(key);
  if (!keyData) {
    throw new TypeError("Unknown key object");
  }
  return keyData;
}
var cleanupRegistry = new FinalizationRegistry((keyData) => {
  keyData.publicKeyData.fill(0);
  keyData.privateSeedData?.fill(0);
  keyData.privateSecretKeyData?.fill(0);
});
function getPublicKeyDataRef(key) {
  const keyData = getInternalKeyData(key);
  if (!keyData.publicKeyData) {
    throw new MlKemOperationError("Failed to get public key data");
  }
  return keyData.publicKeyData;
}
function getPrivateKeyDataRef(key) {
  const keyData = getInternalKeyData(key);
  if (!keyData.privateSeedData || !keyData.privateSecretKeyData) {
    throw new MlKemOperationError("Failed to get private key data");
  }
  return keyData;
}
var noClone = /* @__PURE__ */ Symbol("CryptoKey created by mlkem-wasm cannot be cloned");
var keyIdKey = "_mlkem_wasm";
var emptyToJSON = () => ({});
function createKeyObject(type, extractable, usages, keyData) {
  const key = {
    type,
    extractable,
    algorithm: Object.freeze({ name: ALGORITHM_NAME }),
    usages: Object.freeze(Array.from(usages)),
    [keyIdKey]: noClone
    // to prevent structured cloning
  };
  Object.defineProperty(key, "toJSON", {
    value: emptyToJSON,
    writable: false,
    enumerable: false,
    configurable: false
  });
  Object.setPrototypeOf(key, CryptoKey.prototype);
  internalKeyData.set(key, keyData);
  cleanupRegistry.register(key, keyData);
  return Object.freeze(key);
}
function createPublicKey(publicKeyData, usages) {
  return createKeyObject("public", true, usages, { publicKeyData });
}
function createPrivateKey(publicKeyData, privateSeedData, privateSecretKeyData, extractable, usages) {
  return createKeyObject("private", extractable, usages, {
    publicKeyData,
    privateSeedData,
    privateSecretKeyData
  });
}
function _isSupportedCryptoKey(key) {
  return key instanceof CryptoKey && keyIdKey in key && key[keyIdKey] == noClone && internalKeyData.has(key);
}
function toBase64url(data) {
  return btoa(String.fromCharCode(...data)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function fromBase64url(base64url) {
  const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
  const binary = atob(base64 + "===".slice((base64.length + 3) % 4));
  return Uint8Array.from(binary, (c) => c.charCodeAt(0));
}
var PUBLICKEY_BYTES = 1568;
var SECRETKEY_BYTES = 3168;
var CIPHERTEXT_BYTES = 1568;
var SHARED_SECRET_BYTES = 32;
var KEYPAIR_RANDOM_BYTES = 64;
var ENC_RANDOM_BYTES = 32;
var _module;
async function getModule() {
  if (!_module) {
    _module = await wasm_module_1024_default();
  }
  return _module;
}
var getRandomValues = crypto.getRandomValues.bind(crypto);
function checkAlgorithm(algorithm) {
  const name = typeof algorithm === "string" ? algorithm.toUpperCase() : typeof algorithm === "object" && algorithm !== null && "name" in algorithm && typeof algorithm.name === "string" ? algorithm.name.toUpperCase() : null;
  if (name !== ALGORITHM_NAME) {
    throw new TypeError("Unsupported algorithm");
  }
}
async function internalGenerateKeyPair(coins) {
  const module = await getModule();
  const stackSave = module.stackSave();
  try {
    const pkPtr = module.stackAlloc(PUBLICKEY_BYTES);
    const skPtr = module.stackAlloc(SECRETKEY_BYTES);
    const coinsPtr = module.stackAlloc(KEYPAIR_RANDOM_BYTES);
    module.HEAPU8.set(coins, coinsPtr);
    const result = module._mlkem1024_keypair_derand(pkPtr, skPtr, coinsPtr);
    if (result !== 0) {
      throw new MlKemOperationError("Key generation failed");
    }
    const rawPublicKey = new Uint8Array(PUBLICKEY_BYTES);
    const rawSecretKey = new Uint8Array(SECRETKEY_BYTES);
    const rawSeed = new Uint8Array(coins);
    rawPublicKey.set(module.HEAPU8.subarray(pkPtr, pkPtr + PUBLICKEY_BYTES));
    rawSecretKey.set(module.HEAPU8.subarray(skPtr, skPtr + SECRETKEY_BYTES));
    module.HEAPU8.fill(0, pkPtr, pkPtr + PUBLICKEY_BYTES);
    module.HEAPU8.fill(0, skPtr, skPtr + SECRETKEY_BYTES);
    module.HEAPU8.fill(0, coinsPtr, coinsPtr + KEYPAIR_RANDOM_BYTES);
    return { rawPublicKey, rawSecretKey, rawSeed };
  } finally {
    module.stackRestore(stackSave);
  }
}
async function generateKey(keyAlgorithm, extractable, usages) {
  checkAlgorithm(keyAlgorithm);
  if (!Array.isArray(usages) || usages.some((usage) => !KEY_USAGES.includes(usage))) {
    throw new SyntaxError("Invalid key usages");
  }
  const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(
    getRandomValues(new Uint8Array(KEYPAIR_RANDOM_BYTES))
  );
  const publicKey = createPublicKey(
    rawPublicKey,
    usages.filter(
      (usage) => usage === "encapsulateKey" || usage === "encapsulateBits"
    )
  );
  const privateKey = createPrivateKey(
    rawPublicKey,
    rawSeed,
    rawSecretKey,
    extractable,
    usages.filter(
      (usage) => usage === "decapsulateKey" || usage === "decapsulateBits"
    )
  );
  return {
    publicKey,
    privateKey
  };
}
async function exportKey(format, key) {
  if (!(key instanceof CryptoKey)) {
    throw new TypeError("Expected key to be an instance of CryptoKey");
  }
  checkAlgorithm(key.algorithm);
  if (!key.extractable) {
    throw new MlKemOperationError("Key is not extractable");
  }
  if (format === "spki") {
    if (key.type !== "public") {
      throw new TypeError("Expected key type to be 'public'");
    }
    return rawToDer(MLKEM1024_SPKI, getPublicKeyDataRef(key)).buffer;
  }
  if (format === "pkcs8") {
    if (key.type !== "private") {
      throw new MlKemInvalidAccessError("Expected key type to be 'private'");
    }
    return rawToDer(MLKEM1024_PKCS8, getPrivateKeyDataRef(key).privateSeedData).buffer;
  }
  if (format === "raw-public") {
    if (key.type !== "public") {
      throw new TypeError("Expected key type to be 'public'");
    }
    return new Uint8Array(getPublicKeyDataRef(key)).buffer;
  }
  if (format === "raw-seed") {
    if (key.type !== "private") {
      throw new MlKemInvalidAccessError("Expected key type to be 'private'");
    }
    return new Uint8Array(getPrivateKeyDataRef(key).privateSeedData).buffer;
  }
  if (format === "jwk") {
    const jwk = {
      // 2.2. Set the kty attribute of jwk to "AKP".
      kty: "AKP",
      // 2.3. Set the alg attribute of jwk to the alg value corresponding to
      // the name member of normalizedAlgorithm indicated in Section 8 of
      // [draft-ietf-jose-pqc-kem-01] (Figure 1).
      alg: JWK_ALG,
      // 2.4. Set the pub attribute of jwk to the base64url encoded public
      // key corresponding to the [[handle]] internal slot of key.
      pub: toBase64url(getPublicKeyDataRef(key))
    };
    if (key.type === "private") {
      jwk.priv = toBase64url(getPrivateKeyDataRef(key).privateSeedData);
    }
    jwk.key_ops = key.usages;
    jwk.ext = key.extractable;
    return jwk;
  }
  throw new MlKemNotSupportedError("Format not supported");
}
function bufferSourcetoUint8Array(value) {
  if (ArrayBuffer.isView(value) && value.buffer instanceof ArrayBuffer) {
    return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
  } else if (value instanceof ArrayBuffer) {
    return new Uint8Array(value);
  } else {
    throw new TypeError("Value must be a BufferSource");
  }
}
function bufferSourcetoUint8ArrayCopy(value) {
  return bufferSourcetoUint8Array(value).slice();
}
var MLKEM1024_SPKI = {
  fullLength: 1590,
  prefix: new Uint8Array([
    48,
    130,
    6,
    50,
    48,
    11,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    4,
    3,
    3,
    130,
    6,
    33,
    0
  ])
};
var MLKEM1024_PKCS8 = {
  fullLength: 86,
  prefix: new Uint8Array([
    48,
    84,
    2,
    1,
    0,
    48,
    11,
    6,
    9,
    96,
    134,
    72,
    1,
    101,
    3,
    4,
    4,
    3,
    4,
    66,
    128,
    64
  ])
};
function bytesEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  let diff = 0;
  for (let i = 0; i < a.length; i++) {
    diff |= a[i] ^ b[i];
  }
  return diff === 0;
}
function derToRaw(encoding, der) {
  if (der.length !== encoding.fullLength) {
    throw new MlKemDataError("Invalid encoding");
  }
  const prefix = der.subarray(0, encoding.prefix.length);
  if (!bytesEqual(prefix, encoding.prefix)) {
    throw new MlKemNotSupportedError("Unsupported encoding");
  }
  return der.slice(encoding.prefix.length);
}
function rawToDer(encoding, raw) {
  const der = new Uint8Array(encoding.fullLength);
  der.set(encoding.prefix);
  der.set(raw, encoding.prefix.length);
  return der;
}
async function importKey(format, keyData, algorithm, extractable, usages) {
  checkAlgorithm(algorithm);
  if (format === "spki") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for public key");
    }
    const data = derToRaw(MLKEM1024_SPKI, bufferSourcetoUint8Array(keyData));
    if (data.length !== PUBLICKEY_BYTES) {
      throw new MlKemDataError("Invalid key length");
    }
    return createPublicKey(data, usages);
  }
  if (format === "pkcs8") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "decapsulateKey" && usage !== "decapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for private key");
    }
    const data = derToRaw(MLKEM1024_PKCS8, bufferSourcetoUint8Array(keyData));
    if (data.length !== KEYPAIR_RANDOM_BYTES) {
      throw new MlKemDataError("Invalid key length");
    }
    const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(data);
    return createPrivateKey(
      rawPublicKey,
      rawSeed,
      rawSecretKey,
      extractable,
      usages
    );
  }
  if (format === "raw-public") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for public key");
    }
    const data = bufferSourcetoUint8ArrayCopy(keyData);
    return createPublicKey(data, usages);
  }
  if (format === "raw-seed") {
    if (!Array.isArray(usages) || usages.some(
      (usage) => usage !== "decapsulateKey" && usage !== "decapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for private key");
    }
    const data = bufferSourcetoUint8ArrayCopy(keyData);
    if (data.length !== KEYPAIR_RANDOM_BYTES) {
      throw new MlKemDataError("Invalid key length");
    }
    const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(data);
    return createPrivateKey(
      rawPublicKey,
      rawSeed,
      rawSecretKey,
      extractable,
      usages
    );
  }
  if (format === "jwk") {
    if (typeof keyData !== "object" || keyData === null) {
      throw new MlKemDataError(
        "Expected keyData to be a JsonWebKey dictionary"
      );
    }
    const jwk = keyData;
    if (jwk.priv && usages.some(
      (usage) => usage !== "decapsulateKey" && usage !== "decapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for private key");
    }
    if (!jwk.priv && usages.some(
      (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
    )) {
      throw new SyntaxError("Invalid key usages for public key");
    }
    if (jwk.kty !== "AKP") {
      throw new MlKemDataError("Invalid key type");
    }
    if (jwk.alg !== JWK_ALG && jwk.alg !== "ML-KEM-1024+A256KW") {
      throw new MlKemDataError("Invalid algorithm");
    }
    if (usages.length > 0 && jwk.use && jwk.use !== "enc") {
      throw new MlKemDataError("Invalid key usage");
    }
    if (jwk.key_ops && Array.isArray(jwk.key_ops) && !Array.prototype.every.call(
      jwk.key_ops,
      (op) => KEY_USAGES.includes(op)
    ) || !Array.isArray(jwk.key_ops)) {
      throw new MlKemDataError("Invalid key operations");
    }
    if (jwk.ext === false && extractable) {
      throw new MlKemDataError("Invalid key extractability");
    }
    if (jwk.priv) {
      try {
        const seedData = fromBase64url(jwk.priv);
        if (seedData.length !== KEYPAIR_RANDOM_BYTES) {
          throw new MlKemDataError("Invalid private key length");
        }
        const { rawPublicKey, rawSecretKey, rawSeed } = await internalGenerateKeyPair(seedData);
        const key = createPrivateKey(
          rawPublicKey,
          rawSeed,
          rawSecretKey,
          extractable,
          usages
        );
        if (toBase64url(rawPublicKey) !== jwk.pub) {
          throw new MlKemDataError("Invalid public key data");
        }
        return key;
      } catch {
        throw new MlKemDataError("Invalid private key format");
      }
    } else {
      try {
        const publicKeyData = fromBase64url(jwk.pub);
        if (publicKeyData.length !== PUBLICKEY_BYTES) {
          throw new MlKemDataError("Invalid public key data");
        }
        return createPublicKey(publicKeyData, usages);
      } catch {
        throw new MlKemDataError("Invalid public key format");
      }
    }
  }
  throw new MlKemNotSupportedError("Unsupported key format");
}
async function getPublicKey(key, usages) {
  if (!(key instanceof CryptoKey)) {
    throw new TypeError("Expected key to be an instance of CryptoKey");
  }
  checkAlgorithm(key.algorithm);
  if (key.type !== "private") {
    throw new MlKemInvalidAccessError("Expected key type to be 'private'");
  }
  if (!Array.isArray(usages) || usages.some(
    (usage) => usage !== "encapsulateKey" && usage !== "encapsulateBits"
  )) {
    throw new SyntaxError("Invalid key usages");
  }
  const keyData = getInternalKeyData(key);
  if (!keyData.publicKeyData) {
    throw new MlKemOperationError("Failed to get public key data");
  }
  return createPublicKey(new Uint8Array(keyData.publicKeyData), usages);
}
async function internalEncapsulate(algorithm, encapsulationKey, usage) {
  const module = await getModule();
  checkAlgorithm(algorithm);
  if (!(encapsulationKey instanceof CryptoKey) || encapsulationKey.type !== "public") {
    throw new MlKemInvalidAccessError(
      "Expected publicKey to be an instance of MlKemCryptoKey with type 'public'"
    );
  }
  if (!encapsulationKey.usages.includes(usage)) {
    throw new MlKemInvalidAccessError(`Key usages don't include '${usage}'`);
  }
  const publicKeyData = getPublicKeyDataRef(encapsulationKey);
  if (publicKeyData.length !== PUBLICKEY_BYTES) {
    throw new MlKemOperationError("Invalid public key length");
  }
  const coins = getRandomValues(new Uint8Array(ENC_RANDOM_BYTES));
  const stackSave = module.stackSave();
  try {
    const pkPtr = module.stackAlloc(PUBLICKEY_BYTES);
    const ctPtr = module.stackAlloc(CIPHERTEXT_BYTES);
    const ssPtr = module.stackAlloc(SHARED_SECRET_BYTES);
    const coinsPtr = module.stackAlloc(ENC_RANDOM_BYTES);
    module.HEAPU8.set(publicKeyData, pkPtr);
    module.HEAPU8.set(coins, coinsPtr);
    const result = module._mlkem1024_enc_derand(ctPtr, ssPtr, pkPtr, coinsPtr);
    if (result !== 0) {
      throw new MlKemOperationError("Encapsulation failed");
    }
    const ciphertext = new Uint8Array(CIPHERTEXT_BYTES);
    const sharedKey = new Uint8Array(SHARED_SECRET_BYTES);
    ciphertext.set(module.HEAPU8.subarray(ctPtr, ctPtr + CIPHERTEXT_BYTES));
    sharedKey.set(module.HEAPU8.subarray(ssPtr, ssPtr + SHARED_SECRET_BYTES));
    module.HEAPU8.fill(0, ctPtr, ctPtr + CIPHERTEXT_BYTES);
    module.HEAPU8.fill(0, ssPtr, ssPtr + SHARED_SECRET_BYTES);
    module.HEAPU8.fill(0, pkPtr, pkPtr + PUBLICKEY_BYTES);
    module.HEAPU8.fill(0, coinsPtr, coinsPtr + ENC_RANDOM_BYTES);
    return {
      ciphertext: ciphertext.buffer,
      sharedKey: sharedKey.buffer
    };
  } finally {
    module.stackRestore(stackSave);
  }
}
async function encapsulateBits(algorithm, encapsulationKey) {
  return internalEncapsulate(algorithm, encapsulationKey, "encapsulateBits");
}
async function encapsulateKey(encapsulationAlgorithm, encapsulationKey, sharedKeyAlgorithm, extractable, usages) {
  const { sharedKey: sharedKeyBits, ciphertext } = await internalEncapsulate(
    encapsulationAlgorithm,
    encapsulationKey,
    "encapsulateKey"
  );
  const sharedKey = await crypto.subtle.importKey(
    "raw",
    sharedKeyBits,
    sharedKeyAlgorithm,
    extractable,
    usages
  );
  return {
    sharedKey,
    ciphertext
  };
}
async function internalDecapsulate(algorithm, decapsulationKey, ciphertext, usage) {
  const module = await getModule();
  checkAlgorithm(algorithm);
  if (!(decapsulationKey instanceof CryptoKey) || decapsulationKey.type !== "private") {
    throw new MlKemInvalidAccessError(
      "Expected key to be an instance of MlKemCryptoKey with type 'private'"
    );
  }
  if (!decapsulationKey.usages.includes(usage)) {
    throw new MlKemInvalidAccessError(`Key usages don't include '${usage}'`);
  }
  const secretKeyData = getPrivateKeyDataRef(decapsulationKey).privateSecretKeyData;
  if (!secretKeyData || secretKeyData.length !== SECRETKEY_BYTES) {
    throw new Error("Invalid secret key length");
  }
  const ct = bufferSourcetoUint8Array(ciphertext);
  if (ct.length !== CIPHERTEXT_BYTES) {
    throw new MlKemOperationError("Invalid ciphertext length");
  }
  const stackSave = module.stackSave();
  try {
    const ctPtr = module.stackAlloc(CIPHERTEXT_BYTES);
    const skPtr = module.stackAlloc(SECRETKEY_BYTES);
    const ssPtr = module.stackAlloc(SHARED_SECRET_BYTES);
    module.HEAPU8.set(ct, ctPtr);
    module.HEAPU8.set(secretKeyData, skPtr);
    const result = module._mlkem1024_dec(ssPtr, ctPtr, skPtr);
    if (result !== 0) {
      throw new MlKemOperationError("Decapsulation failed");
    }
    const sharedKey = new Uint8Array(SHARED_SECRET_BYTES);
    sharedKey.set(module.HEAPU8.subarray(ssPtr, ssPtr + SHARED_SECRET_BYTES));
    module.HEAPU8.fill(0, ctPtr, ctPtr + CIPHERTEXT_BYTES);
    module.HEAPU8.fill(0, skPtr, skPtr + SECRETKEY_BYTES);
    module.HEAPU8.fill(0, ssPtr, ssPtr + SHARED_SECRET_BYTES);
    return sharedKey.buffer;
  } finally {
    module.stackRestore(stackSave);
  }
}
async function decapsulateBits(decapsulationAlgorithm, decapsulationKey, ciphertext) {
  return internalDecapsulate(
    decapsulationAlgorithm,
    decapsulationKey,
    ciphertext,
    "decapsulateBits"
  );
}
async function decapsulateKey(decapsulationAlgorithm, decapsulationKey, ciphertext, sharedKeyAlgorithm, extractable, usages) {
  const sharedKeyBits = await internalDecapsulate(
    decapsulationAlgorithm,
    decapsulationKey,
    ciphertext,
    "decapsulateKey"
  );
  const sharedKey = await crypto.subtle.importKey(
    "raw",
    sharedKeyBits,
    sharedKeyAlgorithm,
    extractable,
    usages
  );
  return sharedKey;
}
var mlkem = {
  generateKey,
  exportKey,
  importKey,
  getPublicKey,
  encapsulateBits,
  encapsulateKey,
  decapsulateBits,
  decapsulateKey,
  _isSupportedCryptoKey
};
var mlkem1024_default = mlkem;
export {
  mlkem1024_default as default
};
